import { Tier } from '../enums'

export const FORBIDDEN_TIERS = [Tier.tier90, Tier.tier99]
